import _ from "lodash-es";
import Queries from "../queries/queries2";
import { FIXED2 } from "./fixedTools";


const linesUpdate = async (
  lineType,
  formerLinesList,
  linesList,
  createCallback,
  createCallbackWithoutTiersId,
  updateCallback,
  deleteCallBack,
  bankAccountId
) => {
  // console.log("14 - lineType, formerLinesList, linesList, createCallback, updateCallback, deleteCallBack", lineType, formerLinesList, linesList, createCallback, updateCallback, deleteCallBack);
  console.log("18 - bankAccountId=", bankAccountId);

  let newLinesList = [];
  await Promise.all(
    linesList.map(async (line, index) => {
      const formerLine = _.find(formerLinesList, { id: line.id });
      console.log("line", line);
      console.log("formerLine", formerLine);
      if (!formerLine) {
        // console.log("createCallback", line);

        line["taxPieces"].forEach(o => {
          o.tax = { connect: { id: o.tax.id } };
        });
       
        let valueTax = 0.0;
        for (const element of line["taxPieces"]) {
          valueTax = FIXED2(valueTax + element.amount);
        }
        if (
          line["amount"] < 0.0
        ) {
          valueTax = -valueTax;
        }
        line["valueTax"] = valueTax;

        line["taxPieces"] = { create: line["taxPieces"] };
        // console.log("createCallback updated", line);

        // console.log("42 - line=", line);
        const lineCreated = line.tiersId
          ? await createCallback({            
            variables: line,
            refetchQueries: [{
              query: Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
              variables: {
                bankAccountId: bankAccountId
              }
            }]
          })
          : await createCallbackWithoutTiersId({
            variables: line,
            refetchQueries: [{
              query: Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
              variables: {
                bankAccountId: bankAccountId
              }
            }]
          });

        // console.log("lineCreated", lineCreated, lineCreated.data[`update${lineType}Line`])
        await newLinesList.push(lineCreated.data[`create${lineType}Line`]);
      } else if (formerLine !== line) {
        // console.log("updateCallback", line);

        try {
          if (line) {
            await deleteCallBack({
              variables: line
            });
            // console.log("1res", lineUpdatedDeleted);
          }

          line["taxPieces"] = _.map(line["taxPieces"], o => {
            console.log("o", o);
            return {
              tax: { connect: { id: o.tax.id } },
              amount: o.amount,
              label: o.label,
              taux: o.taux,
              baseHT: o.baseHT
            };
          });

          let valueTax = 0.0;
          for (const element of line["taxPieces"]) {
            valueTax = FIXED2(valueTax + element.amount);
          }
          if (
            line["amount"] < 0.0
          ) {
            valueTax = -valueTax;
          }
          line["valueTax"] = valueTax;

          // console.log("tp", line["taxPieces"]);
          line["taxPieces"] = { create: line["taxPieces"] };

          // console.log("85 - line=", line);
          const lineReCreated = line.tiersId
            ? await createCallback({ variables: line })
            : await createCallbackWithoutTiersId({ variables: line });

          // console.log("2res", lineReCreated);
          // console.log("lineUpdated", lineUpdated, lineUpdated.data[`update${lineType}Line`])
          await newLinesList.push(lineReCreated.data[`create${lineType}Line`]);
        } catch (e) {
          // console.log("e", e);
          throw e;
        }
      }
    })
  );
  const deleteLines = (newLinesList, formerLinesList) => {
    //if (newLinesList.length !== formerLinesList.length) {
    var ids = _.differenceWith(
      _.map(formerLinesList, "id"),
      _.map(newLinesList, "id"),
      _.isEqual
    );
    //console.log("IDS", ids);
    ids.map(id => {
      //console.log("deleteCallBack", id);
      return deleteCallBack({ variables: { id } });
    });
    //}
  };


  await deleteLines(newLinesList, formerLinesList);
  console.log("newLinesList", newLinesList)
  return newLinesList;
};

export default linesUpdate;
